import {metadaApi} from '@dms/api/base';

import {
  DeleteSpacesRequest,
  DeleteSpacesRequestSchema,
  DeleteSpacesResponse,
  DeleteSpacesResponseSchema,
  GetSpaceRequest,
  GetSpaceRequestSchema,
  GetSpaceResponse,
  GetSpaceResponseSchema,
  GetSpacesRequest,
  GetSpacesRequestSchema,
  GetSpacesResponse,
  GetSpacesResponseSchema,
  PatchSpaceRequest,
  PatchSpaceRequestSchema,
  PatchSpaceResponse,
  PatchSpaceResponseSchema,
  PostSpaceRequest,
  PostSpaceRequestSchema,
  PostSpaceResponse,
  PostSpaceResponseSchema,
} from './types';

export const metadaWarehouseSpaceApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getSpaces: build.query<GetSpacesResponse, GetSpacesRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/space`,
        method: 'GET',
        params: {warehouseId: queryArg.warehouseId},
        queryArg,
      }),
      providesTags: ['spaces'],
      extraOptions: {
        requestSchema: GetSpacesRequestSchema,
        responseSchema: GetSpacesResponseSchema,
      },
    }),
    getSpace: build.query<GetSpaceResponse, GetSpaceRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/space/${queryArg.spaceId}`,
        method: 'GET',
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [{type: 'space', id: queryArg.spaceId}],
      extraOptions: {
        requestSchema: GetSpaceRequestSchema,
        responseSchema: GetSpaceResponseSchema,
      },
    }),
    postSpace: build.mutation<PostSpaceResponse, PostSpaceRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/space`,
        method: 'POST',
        body: queryArg,
        queryArg,
      }),
      invalidatesTags: ['spaces'],
      extraOptions: {
        requestSchema: PostSpaceRequestSchema,
        responseSchema: PostSpaceResponseSchema,
      },
    }),
    patchSpace: build.mutation<PatchSpaceResponse, PatchSpaceRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/space/${queryArg.spaceId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'spaces',
        {type: 'space', id: queryArg.spaceId},
      ],
      extraOptions: {
        requestSchema: PatchSpaceRequestSchema,
        responseSchema: PatchSpaceResponseSchema,
      },
    }),
    deleteSpaces: build.mutation<DeleteSpacesResponse, DeleteSpacesRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/space/delete`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: ['spaces'],
      extraOptions: {
        requestSchema: DeleteSpacesRequestSchema,
        responseSchema: DeleteSpacesResponseSchema,
      },
    }),
  }),
});

export const {
  useGetSpacesQuery,
  useLazyGetSpacesQuery,
  useGetSpaceQuery,
  useLazyGetSpaceQuery,
  usePostSpaceMutation,
  usePatchSpaceMutation,
  useDeleteSpacesMutation,
} = metadaWarehouseSpaceApi;
